module.exports = {
  AB1: 'ab1',
  AB2: 'ab2',
  AV1: 'av1',
  FB1: 'fb1',
  FB2: 'fb2',
  VB1: 'vb1',
  VB2: 'vb2',
  SR1: 'sr1',
  SR2: 'sr2',
  SV1: 'sv1',
  SV2: 'sv2',
  AM1: 'am1',
  AM2: 'am2',
  AR1: 'ar1',
};
